import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, Col, Container, Modal, Row, Form } from "react-bootstrap"
import { getCompanias,importCompaniasFromEbroker  } from "../../actions/other/companiasActions"
import { RootState, AppDispatch } from "../../store"
import { CustomDataTable } from "../../components/design/Datatables/CustomDataTable"
import { useAuth } from "../../components/auth/useAuth"
import { useTranslation } from "react-i18next"
import Swal from "sweetalert2"

export interface Company {
    _id?: string
    name?: string
    ebrokerId?: number
    abbreviation?: string
    clave?: string

}

export default function CompanyManagement() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch: AppDispatch = useDispatch()

    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(25)
    const [search, setSearch] = useState<string>("")
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState<number>(0)

    const { companias } = useSelector((state: RootState) => state.companias)

    useEffect(() => {
        if (clientauth) {
            dispatch(getCompanias() as any)
        }
    }, [dispatch, t, clientauth])

    const handleImportCompanies = () => {
        Swal.fire({
            icon: 'question',
            title: t('companiasTranslate.importCompanias')!,
            text: t('companiasTranslate.importCompaniasAreYouSure')!,
            showDenyButton: true,
            confirmButtonText: t('global.ok')!,
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(importCompaniasFromEbroker())
            }
        })
    }



    const columnsCompanias = [
        {
            name: t("companiasTranslate.ebrokerId"),
            selector: (company: Company) => company.ebrokerId?.toString() || "-",
            sortable: true,
            maxWidth: "120px",
            center: true,
        },
        {
            name: t("companiasTranslate.name"),
            selector: (company: Company) => company.name || "",
            sortable: true,
            wrap: true,
        },
        {
            name: t("companiasTranslate.abbreviation"),
            selector: (company: Company) => company.abbreviation || "-",
            sortable: true,
            maxWidth: "160px",
        },
        {
            name: t("companiasTranslate.clave"),
            selector: (company: Company) => company.clave || "-",
            sortable: true,
            maxWidth: "140px",
        }
    ]


    return (
        <Container className='p-1 py-5 p-md-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('menus.companias')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <button className="btn btn-primary" onClick={handleImportCompanies}>
                        {t("companiasTranslate.importCompanias")}
                    </button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    {companias?.length > 0 ? (
                                        <CustomDataTable
                                            columns={columnsCompanias}
                                            data={companias}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            searchText={search}
                                            onChangeRowsPerPage={(newLimit: number) => {
                                                setLimit(newLimit);
                                                setPage(1);
                                            }}
                                            onChangePage={(newPage: number) => {
                                                setPage(newPage);
                                            }}
                                        />
                                    ) : (
                                        <h4 className="mt-4">{t("companiasTranslate.thereisnotcompanias")}</h4>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}